import { PopCcontainer, PopupTitle } from '../Css/Pop';
import Modal from '../Modal';
import { Tit } from '../Titles';
import ApplyStep01 from '@/assets/img/support/support_step_01@2x.png';
import ApplyStep02 from '@/assets/img/support/support_step_02@2x.png';
import ApplyStep03 from '@/assets/img/support/support_step_03@2x.png';
import ReviewStep01 from '@/assets/img/tmp/child-participation/village_step_01@2x.png';
import ReviewStep02 from '@/assets/img/tmp/child-participation/village_step_02@2x.png';
import Button, { BtnClose } from '@/components/Button';
import PartyAppyComplete from '@/page-blocks/involve/individual/PartyAppyComplete';
import PartyAppyStep1, {
  PartyApplyStep1Data,
} from '@/page-blocks/involve/individual/PartyAppyStep1';
import PartyAppyStep2, {
  PartyApplyStep2Data,
} from '@/page-blocks/involve/individual/PartyAppyStep2';
import PartyAppyStep3, {
  PartyApplyStep3Data,
} from '@/page-blocks/involve/individual/PartyAppyStep3';
import PartyKit from '@/page-blocks/involve/individual/PartyKit';
import PartyReviewComplete from '@/page-blocks/involve/individual/PartyReviewComplete';
import PartyReviewStep1, {
  PartyReviewStep1Data,
} from '@/page-blocks/involve/individual/PartyReviewStep1';
import PartyReviewStep2, {
  PartyReviewStep2Data,
} from '@/page-blocks/involve/individual/PartyReviewStep2';
import React, { FC, useState, useMemo } from 'react';
import styled, { css } from 'styled-components';

export interface ModalProps {
  isOpen?: boolean;
  // 모달 바깥쪽 누를시 닫을수 있는지 여부
  dismissable?: boolean;
  // 닫힘요청시 콜백
  onRequestClose: () => void;
  maxWidth?: string;
}

interface PartyLayerProps extends ModalProps {
  PopSid: string | number;
  PopTitle: string;
}

const StepImage = styled.img<{ active?: boolean }>`
  width: 100%;
  margin: 0 auto;
  box-sizing: content-box;
  object-fit: contain;
  padding: 32px 0;
  display: none;
  ${({ active }) => {
    if (active) {
      return `
        display: block;
      `;
    }
    return ``;
  }}
`;
const StepBody = styled.div``;
const ToggleBoxActive = css`
  display: block;
`;
const ToggleBox = styled.div<{ active: boolean }>`
  display: none;
  ${({ active }) => active && ToggleBoxActive};
`;
const PopContent = styled.div`
  padding-bottom: 96px;
  max-width: 600px;
  margin: 0 auto;
`;
const KitContainer = styled.div``;
const ApplyContainer = styled.div`
  ${StepImage} {
    max-width: 546px;
  }
`;
const ReviewContainer = styled.div`
  ${StepImage} {
    max-width: 297px;
  }
`;

const PartyLayerPopup: FC<PartyLayerProps> = ({ onRequestClose, ...props }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [reviewStep, setReviewStep] = useState(1);

  const [partyStep1Data, setPartyStep1Data] = useState<PartyApplyStep1Data>();
  const [partyStep2Data, setPartyStep2Data] = useState<PartyApplyStep2Data>();
  const [partyStep3Data, setPartyStep3Data] = useState<PartyApplyStep3Data>();
  const totalData = useMemo(
    () => ({ ...partyStep1Data, ...partyStep2Data, ...partyStep3Data }),
    [partyStep1Data, partyStep2Data, partyStep3Data],
  );

  const [
    reviewStep1Data,
    setReviewStep1Data,
  ] = useState<PartyReviewStep1Data>();
  const [
    reviewStep2Data,
    setReviewStep2Data,
  ] = useState<PartyReviewStep2Data>();

  const totalReviewData = useMemo(
    () => ({ ...reviewStep1Data, ...reviewStep2Data }),
    [reviewStep1Data, reviewStep2Data],
  );

  const currentParent = (data) => {
    setCurrentStep(4);
  };
  const currentReviewParent = (data) => {
    setReviewStep(3);
  };

  return (
    <Modal onRequestClose={onRequestClose} maxWidth="880px" {...props}>
      <PopCcontainer>
        <PopupTitle>
          <h2>
            <Tit
              size="s3"
              color="sky"
              dangerouslySetInnerHTML={{ __html: props.PopTitle }}
            />
          </h2>
          <BtnClose onClick={() => onRequestClose()}>
            <span className="a11y">닫기</span>
          </BtnClose>
        </PopupTitle>
        {props.PopSid === 0 && (
          <KitContainer>
            <PartyKit />
          </KitContainer>
        )}
        {props.PopSid === 1 && (
          <ApplyContainer>
            <StepImage
              src={ApplyStep01}
              active={currentStep === 1}
              alt="Step1"
            />
            <StepImage
              src={ApplyStep02}
              active={currentStep === 2}
              alt="Step2"
            />
            <StepImage
              src={ApplyStep03}
              active={currentStep === 3}
              alt="Step3"
            />
            <PopContent>
              <ToggleBox active={currentStep === 1}>
                <StepBody>
                  <PartyAppyStep1
                    onSubmit={(data) => {
                      setPartyStep1Data(data);
                      setCurrentStep(2);
                    }}
                  />
                </StepBody>
              </ToggleBox>
              <ToggleBox active={currentStep === 2}>
                <StepBody>
                  <PartyAppyStep2
                    onSubmit={(data) => {
                      setPartyStep2Data(data);
                      setCurrentStep(3);
                    }}
                  />
                </StepBody>
              </ToggleBox>
              <ToggleBox active={currentStep === 3}>
                <StepBody>
                  <PartyAppyStep3
                    currentParent={currentParent}
                    totalData={totalData}
                    onSubmit={(data) => {
                      setPartyStep3Data(data);
                    }}
                  />
                </StepBody>
              </ToggleBox>
              <ToggleBox active={currentStep === 4}>
                <StepBody>
                  <PartyAppyComplete />
                  <div
                    className="btn-wrap"
                    css={`
                      margin-top: 80px;
                      text-align: center;
                    `}
                  >
                    <Button
                      full
                      type="button"
                      onClick={() => {
                        onRequestClose();
                      }}
                    >
                      확인
                    </Button>
                  </div>
                </StepBody>
              </ToggleBox>
            </PopContent>
          </ApplyContainer>
        )}
        {props.PopSid === 2 && (
          <ReviewContainer>
            <StepImage
              src={ReviewStep01}
              active={reviewStep === 1}
              alt="Step1"
            />
            <StepImage
              src={ReviewStep02}
              active={reviewStep === 2}
              alt="Step2"
            />
            <PopContent>
              <ToggleBox active={reviewStep === 1}>
                <StepBody>
                  <PartyReviewStep1
                    onSubmit={(data) => {
                      setReviewStep1Data(data);
                      console.log(data);
                      setReviewStep(2);
                    }}
                  />
                </StepBody>
              </ToggleBox>
              <ToggleBox active={reviewStep === 2}>
                <StepBody>
                  <PartyReviewStep2
                    currentReviewParent={currentReviewParent}
                    totalReviewData={totalReviewData}
                    onSubmit={(data) => {
                      setReviewStep2Data(data);
                    }}
                  />
                </StepBody>
              </ToggleBox>
              <ToggleBox active={reviewStep === 3}>
                <StepBody>
                  <PartyReviewComplete />
                  <div
                    className="btn-wrap"
                    css={`
                      margin-top: 80px;
                      text-align: center;
                    `}
                  >
                    <Button
                      full
                      type="button"
                      onClick={() => {
                        onRequestClose();
                      }}
                    >
                      확인
                    </Button>
                  </div>
                </StepBody>
              </ToggleBox>
            </PopContent>
          </ReviewContainer>
        )}
      </PopCcontainer>
    </Modal>
  );
};

export default PartyLayerPopup;
